import React from "react";

const footer = (props) => {
  return (
    <footer className="main-footer">
      <strong>
        Copyright &copy; 2023-2033 <a href="https://www.vtott.com/">VTOTT</a>.
      </strong>
      All rights reserved.
      <div className="float-right d-none d-sm-inline-block">
        <b>Version</b> 1.0
      </div>
    </footer>
  );
};

export default footer;
